import React, { useEffect } from 'react';

import Unsaved from 'components/Misc/Unsaved';

import Edit from 'containers/Administrator/Users/Profile/Settings/Edit';
import Address from 'containers/Administrator/Users/Profile/Settings/Address';
import Recovery from 'containers/Administrator/Users/Profile/Settings/Recovery';
import Delete from 'containers/Administrator/Users/Profile/Settings/Delete';

import { useUserEditStore } from 'store/user/useUserEditStore';
import { useUserAddressStore } from 'store/user/useUserAddressStore';

const Settings = ({ setTab }) => {
	// Update selected tab
	useEffect(() => setTab(null), [setTab]);

	const editedUser = useUserEditStore(state => state.edited);
	const editedAddress = useUserAddressStore(state => state.edited);
	console.log(editedUser, editedAddress);

	return (
		<>
			{/* User's data edit */}
			<Edit />

			{/* User's data edit */}
			<Address />

			{/* User's recovery email */}
			<Recovery />

			{/* User's removal */}
			<Delete />

			{/* Show confirm on leave */}
			<Unsaved enabled={editedUser || editedAddress} />
		</>
	);
};

export default Settings;